<!-- 支付查询 同步选手信息 -->
<template>
    <div>
        <div class="page-form" v-if="isShow">
            <PageBack :title="title" />
            <div class="size20 center mg-b-10 bold">{{ pubTitle }}</div>
            <el-form :model="searchForm" ref="searchForm"  label-width="100px" :inline="true">                 
                <el-form-item label="支付状态" prop="status" >
                    <el-select v-model="searchForm.status">
                        <el-option 
                            v-for="item in statusOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="searchQuery('searchForm')">查询</el-button>
                </el-form-item>          
            </el-form>
            <div class="custom-table custom-table2">                
                <el-table :data="tableData"         
                    style="width: 100%" border>
                    <el-table-column   
                        v-for="(item, index) in dynamicHeaders"
                        :key="index"
                        :prop="item.prop"
                        :label="item.label" 
                        align="center">
                    </el-table-column>
                </el-table>
                <pagination
                style="text-align:right"
                v-show="total > 10"
                :total="total"
                :page.sync="queryParams.page"
                :limit.sync="queryParams.pagesize"
                @pagination="initData"/>
            </div>
            <!-- :disabled="disabled" :disabled="disabled2" -->
            <el-row class="mg-t-10" v-if="showButton">
                <el-button type="success" @click="handleMatch" 
                    >{{ matchButtonMsg }}</el-button>
                <el-button type="primary" @click="handleMermber" 
                    >{{ memberButtonMsg }}</el-button>     
                <el-button @click="handleExport" type="success" size="medium">导出</el-button>          
            </el-row>  
            <el-row class="red">请先同步比赛信息，再同步会员信息！</el-row>          
        </div>
        <!-- <div v-else>
            <el-empty description="暂无数据" :image-size="400"></el-empty>
        </div> -->
    </div>
    </template>
    
<script>
import PageBack from '@/components/PageHeader'
import pagination  from '@/components/Pagination'
export default {
    components:{
        pagination,
        PageBack
    },
    data(){
        return{
            isShow: false,
            tableData:[],
            searchForm:{
                status: 0
            },
            tableHeaders: [
                // {label: '标题', prop: 'title'},                   
                {label: '选手', prop: 'username'},
                {label: '推荐人', prop: 'introName'},
                {label: '付款金额', prop: 'totalFee'},
                {label: '退款金额', prop: 'refundFee'},                    
                {label: '比赛状态', prop: 'matchStatus'},
                {label: '会员状态', prop: 'memberStatus'},               
                {label: '状态', prop: 'priceStatus'},
                {label: '日期', prop: 'date'},
            ],
            dynamicHeaders:[],
            pubTitle: '',
            queryParams: {
                page: 1,
                pagesize: 10
            },
            total:0,
            disabled: false,
            disabled2:true,
            showButton: false,
            matchButtonMsg: '同步比赛信息',
            memberButtonMsg: '同步会员信息',
            // 状态 0：支付完成；1：待支付；2：取消支付；3：支付失败；4：退款申请；6：退款完成；7：退款失败； 空查所有
            statusOption:[
                {label:'支付完成', value:0},
                {label:'待支付', value:1},                
                {label:'退款申请', value:4},
                {label:'退款完成', value:6},
            ],
            exportData:[] 
        }
    },
    computed:{
        title(){
            return this.$route.meta.title
        }, 
        publishId(){
            return this.$route.query.id
        } 
    },
    created(){
        
    },
    mounted() {
        this.initData()
    },
    methods: {
        initData(){
            let params = {
                opcode: this.$code.AdminIntroPayment,
                i_serial_mark: this.publishId,
                c_status: this.searchForm.status,
                start_date: 0,
                end_date: 0,   
                pagesize: this.queryParams.pagesize,
                page: this.queryParams.page,
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable 
                    this.total = res.Data.SumCount
                    if(result.length > 0){
                        this.tableData = result.map(item=>{                    
                            return{
                                title: item['标题'],
                                username: item['用户名'],
                                introName: item['推荐人'],
                                totalFee: '￥'+(item['金额(/分)'])/100,
                                refundFee: '￥'+(item['退款金额(/分)'])/100,    
                                serial: item['标识'],                           
                                matchStatus: item['比赛同步状态'],
                                memberStatus: item['会员信息同步状态'],
                                priceStatus: item['状态'],
                                date: this.$help.formatDate(item['日期']),
                            }
                        })  

                    this.pubTitle = this.tableData[0].title  
                    this.isShow = true
                    // 获取所有唯一的字段名
                    const fields = Array.from(new Set(this.tableData.flatMap(Object.keys)));
                    // 过滤出至少有一个非空值的字段
                    let arr= fields.filter(field => this.tableData.some(row => row[field] !== null && row[field] !== undefined && row[field] !== ''));

                    this.dynamicHeaders = this.tableHeaders.filter(i=>arr.includes(i.prop))
                    this.showButton = true
                    let matchShow = this.tableData.filter(i=> i.matchStatus === '未同步完成')
                        if(matchShow.length > 0){
                            this.disabled = false
                            this.matchButtonMsg = '同步比赛信息'
                        }else{
                            this.disabled = true
                            this.matchButtonMsg = '同步比赛信息完成'
                        }
                    let memberShow = this.tableData.filter(i=> i.memberStatus === '未同步完成')
                        if(memberShow.length > 0){                                                
                            if(this.disabled){    
                                this.disabled2 = false                               
                            }else{
                                this.disabled2 = true
                            }
                            this.memberButtonMsg = '同步会员信息'
                        }else{                           
                            this.disabled2 = true
                            this.memberButtonMsg = '同步会员信息完成'
                        }
                    }else{
                        // this.isShow = true
                        this.showButton = false
                    }                               
                }else{
                    this.$message.error(res.Message)
                    this.showButton = false
                }
            })
        },
        handleMermber(){
            let params = {
                opcode: this.$code.UpdateMemberInfo,
                i_serial_mark: this.publishId,
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    this.$message.success('会员信息同步完成！')
                    this.initData()
                }else{
                    this.$message.error('会员信息同步失败！')
                }
            })
        },
        handleMatch(){
            let params = {
                opcode: this.$code.UpdateMatchInfo,
                i_serial_mark: this.publishId,
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){                    
                    this.$message.success('比赛信息同步完成！')
                    this.initData()
                }else{
                    this.$message.error('比赛信息同步失败！')
                }
            })
        },
        searchQuery() {
            this.initData()
        },
        getExportData(){
            let params = {
                opcode: this.$code.AdminIntroPayment,
                i_serial_mark: this.publishId,
                c_status: this.searchForm.status,
                start_date: 0,
                end_date: 0,   
                pagesize: '',
                page: '',
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable 
                    this.total = res.Data.SumCount
                    if(result.length > 0){                       
                        // 导出的数据格式
                        this.exportData = result.map(item=>{
                            return{  
                                '流水号': item['流水号'],                          
                                // '标题': item['标题'],
                                '选手': item['用户名'],
                                '推荐人': item['推荐人'],
                                '付款金额': '￥'+(item['金额(/分)'])/100,
                                '退款金额': '￥'+(item['退款金额(/分)'])/100,                              
                                '比赛状态': item['比赛同步状态'],
                                '会员状态': item['会员信息同步状态'],
                                '支付状态': item['状态'],
                                '日期': this.$help.formatDate(item['日期']),
                            }
                        })
                    }
                }
            })
        },
        handleExport(){
            this.getExportData()
            setTimeout(()=>{
                if(this.exportData.length > 0){                
                    this.$help.ExportFormData(this.exportData,this.pubTitle)
                }else{
                    this.$message.error('暂无数据')
                }   
            },500)                    
        }
    },
}
</script>
<style lang='scss' scoped>
    @import '@/assets/css/style.scss';
    .custom-table >>> .el-table__header-wrapper tr th{
    font-size: 16px;
    color: #000;
}
.custom-table .el-table__cell{
    font-size: 20px;
}
.custom-table >>> .el-table{
    font-size: 20px;
}
.custom-table >>> .el-table .cell{
    font-size: 20px;
}
.custom-table >>> .el-input{
    font-size: 20px;
}
.custom-table >>> .gold-row{
    background-color: #FFD700;
}
.custom-table >>> .silver-row{
    background-color: #C0C0C0;
}
.custom-table >>> .brown-row{
    background-color: #CD7F32;
}
</style>


// WEBPACK FOOTER //
// src/views/playerScore/paymentQuery.vue